/**
 * Search API Service
 *
 * Task 238: Global Search (Cmd+K)
 * Provides search across matters, documents, clauses, and issues.
 */

import { apiClient } from './client';

export interface SearchResult {
  type: 'matter' | 'document' | 'clause' | 'issue';
  id: string;
  title: string;
  subtitle: string;
  matter_id?: string;
  document_id?: string;
  clause_id?: string;
  project_id?: string;
}

export interface SearchResponse {
  results: SearchResult[];
  total_count: number;
  query: string;
}

class SearchAPI {
  /**
   * Search across matters, documents, clauses, and issues.
   * @param query - Search string (min 2 chars)
   * @param matterId - Optional matter ID to scope search
   * @returns Categorized search results
   */
  async search(query: string, matterId?: string): Promise<SearchResponse> {
    const params: Record<string, string> = { q: query };
    if (matterId) {
      params.matter_id = matterId;
    }
    const response = await apiClient.get<SearchResponse>('/api/v1/search', {
      params,
    });
    return response.data;
  }
}

export const searchApi = new SearchAPI();
